import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useUsers } from '@/lib/queries';
import { formatDate } from '@/lib/utils';

export function UsersListPage() {
  const [q, setQ] = useState('');
  const users = useUsers(q.trim() || undefined);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Users</h1>
        <p className="text-muted-foreground">
          Users appear here once they receive a purchase event from a connected shop.
        </p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <CardTitle className="flex-1">All users</CardTitle>
            <div className="relative w-72">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Discord ID, username…"
                className="pl-9"
              />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {users.isLoading && <p className="text-sm text-muted-foreground">loading…</p>}
          {users.data?.length === 0 && (
            <p className="text-sm text-muted-foreground">
              No users yet. Shop purchase webhooks create entries here.
            </p>
          )}
          {users.data && users.data.length > 0 && (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Discord ID</TableHead>
                  <TableHead>Username</TableHead>
                  <TableHead>Display name</TableHead>
                  <TableHead>Created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {users.data.map((u) => (
                  <TableRow key={u.discordId}>
                    <TableCell>
                      <Link
                        to={`/users/${u.discordId}`}
                        className="font-mono text-sm text-primary hover:underline"
                      >
                        {u.discordId}
                      </Link>
                    </TableCell>
                    <TableCell>{u.username ?? '—'}</TableCell>
                    <TableCell>{u.displayName ?? '—'}</TableCell>
                    <TableCell className="text-xs text-muted-foreground">
                      {formatDate(u.createdAt)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
